"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("util");

var address_1 = require("../address");

var utils_1 = require("../utils");

var transaction_response_formatter_1 = require("./transaction-response-formatter");

function toRawBlockHeaderResponse(block) {
  return {
    hash: block.hash ? utils_1.bufferToHex(block.hash) : null,
    parentHash: utils_1.bufferToHex(block.parentHash),
    sha3Uncles: utils_1.bufferToHex(block.sha3Uncles),
    miner: block.miner.toString(),
    stateRoot: utils_1.bufferToHex(block.stateRoot),
    transactionsRoot: utils_1.bufferToHex(block.transactionsRoot),
    receiptsRoot: utils_1.bufferToHex(block.receiptsRoot),
    logsBloom: block.logsBloom ? utils_1.bufferToHex(block.logsBloom) : null,
    difficulty: utils_1.numberToHex(block.difficulty),
    number: block.number ? utils_1.numberToHex(block.number) : null,
    gasLimit: utils_1.numberToHex(block.gasLimit),
    gasUsed: utils_1.numberToHex(block.gasUsed),
    timestamp: utils_1.numberToHex(block.timestamp),
    extraData: utils_1.bufferToHex(block.extraData),
    nonce: block.nonce ? utils_1.bufferToHex(block.nonce) : null
  };
}

exports.toRawBlockHeaderResponse = toRawBlockHeaderResponse;

function toRawBlockResponse(block) {
  return _objectSpread({}, toRawBlockHeaderResponse(block), {
    totalDifficulty: utils_1.numberToHex(block.totalDifficulty),
    size: utils_1.numberToHex(block.size),
    transactions: block.transactions.map(function (tx) {
      return Buffer.isBuffer(tx) ? utils_1.bufferToHex(tx) : transaction_response_formatter_1.toRawTransactionResponse(tx);
    }),
    uncles: block.uncles
  });
}

exports.toRawBlockResponse = toRawBlockResponse;

function fromRawBlockHeaderResponse(block) {
  return {
    hash: block.hash ? utils_1.hexToBuffer(block.hash) : null,
    parentHash: utils_1.hexToBuffer(block.parentHash),
    sha3Uncles: utils_1.hexToBuffer(block.sha3Uncles),
    miner: address_1.Address.fromString(block.miner),
    stateRoot: utils_1.hexToBuffer(block.stateRoot),
    transactionsRoot: utils_1.hexToBuffer(block.transactionsRoot),
    receiptsRoot: utils_1.hexToBuffer(block.receiptsRoot),
    logsBloom: block.logsBloom ? utils_1.hexToBuffer(block.logsBloom) : null,
    difficulty: utils_1.hexToNumberString(block.difficulty),
    number: block.number ? utils_1.hexToNumber(block.number) : null,
    gasLimit: utils_1.hexToNumber(block.gasLimit),
    gasUsed: utils_1.hexToNumber(block.gasUsed),
    timestamp: utils_1.hexToNumber(block.timestamp),
    extraData: utils_1.hexToBuffer(block.extraData),
    nonce: block.nonce ? utils_1.hexToBuffer(block.nonce) : null
  };
}

exports.fromRawBlockHeaderResponse = fromRawBlockHeaderResponse;

function fromRawBlockResponse(block) {
  return _objectSpread({}, fromRawBlockHeaderResponse(block), {
    totalDifficulty: utils_1.hexToNumberString(block.totalDifficulty),
    size: utils_1.hexToNumber(block.size),
    transactions: block.transactions.map(function (tx) {
      return util_1.isString(tx) ? utils_1.hexToBuffer(tx) : transaction_response_formatter_1.fromRawTransactionResponse(tx);
    }),
    uncles: block.uncles
  });
}

exports.fromRawBlockResponse = fromRawBlockResponse;